/** Codex ACP mode id selected from adapter-reported capabilities. */
export type CodexPermissionMode = string;

/** User preference key (User DO / PATCH me/preferences). */
export const CODEX_LAST_PERMISSION_MODE_PREF_KEY = 'codexLastPermissionMode' as const;

export function isCodexPermissionMode(value: string): value is CodexPermissionMode {
  return value.trim() !== '';
}

/** Returns a selected Codex ACP mode id, or null when missing/invalid. */
export function normalizeCodexPermissionModeInput(raw: unknown): CodexPermissionMode | null {
  if (typeof raw !== 'string') return null;
  const t = raw.trim();
  return isCodexPermissionMode(t) ? t : null;
}
